function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clippath);}.cls-3{opacity:.08;}.cls-4{opacity:.11;}.cls-5{fill:#002a33;}.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11{fill:#fff;}.cls-12{fill:#fff29c;}.cls-13{fill:#fece28;}.cls-14{fill:#febb22;}.cls-15{fill:#6cb9b2;}.cls-16{clip-path:url(#clippath-1);}.cls-7{opacity:.14;}.cls-8{opacity:.18;}.cls-17,.cls-10{opacity:.24;}.cls-18{opacity:.36;}.cls-9{opacity:.51;}.cls-11{opacity:.46;}"), /*#__PURE__*/React.createElement("clipPath", {
  id: "clippath"
}, /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-1",
  cx: 139.99,
  cy: 139.77,
  rx: 123.12,
  ry: 122.64
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clippath-1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M93.81,72.29c0,4.07-.96,8.08-2.79,11.67l-4.96,9.73c-2.44,4.79-3.71,10.13-3.71,15.55v95.72c0,14.77,12.01,26.78,26.78,26.78h62.48c14.77,0,26.78-12.01,26.78-26.78V109.25c0-5.43-1.28-10.77-3.71-15.55l-4.93-9.76c-1.81-3.57-2.75-7.56-2.75-11.6v-4.82s.05-.03,.07-.04c-.95,.52-2.03,.84-3.19,.89-28.97,1.18-57.98,1.18-86.95,0-1.16-.05-2.24-.37-3.19-.89,.02,.01,.05,.03,.07,.04v4.78Z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "cls-5",
  cx: 139.86,
  cy: 139.86,
  r: 131.36
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M139.86,279.72C62.74,279.72,0,216.98,0,139.86S62.74,0,139.86,0s139.86,62.74,139.86,139.86-62.74,139.86-139.86,139.86Zm0-262.72c-67.75,0-122.86,55.11-122.86,122.86s55.11,122.86,122.86,122.86,122.86-55.11,122.86-122.86S207.6,17,139.86,17Z"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-15",
  x: -22.62,
  y: -9.51,
  width: 319.38,
  height: 319.38
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-3",
  cx: 139.78,
  cy: 241.82,
  rx: 91.48,
  ry: 4.2
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-13",
  d: "M158.55,84.1c-.88,.93-1.41,2.14-1.74,3.36-.36,1.33-.49,2.73-.49,4.11-.01,3.49,.72,6.97,1.79,10.28,1.24,3.84,2.97,7.53,5.14,10.93,1.92,3.01,4.21,5.89,7.04,8.08,1.85,1.43,4.2,2.79,6.63,2.62,2.47-.18,4.04-2.21,4.74-4.43,.5-1.6,.64-3.3,.61-4.96-.05-3.81-.96-7.61-2.24-11.18-1.33-3.72-3.11-7.29-5.33-10.56-1.91-2.82-4.18-5.53-6.96-7.53-1.31-.93-2.77-1.75-4.35-2.07-.81-.17-1.65-.2-2.46-.02-.29,.07-.56,.16-.83,.28-.58,.26-1.1,.63-1.55,1.1Zm9.17,4.16c2.16,1.43,3.89,3.4,5.37,5.5,1.63,2.31,3,4.8,4.09,7.41,.55,1.33,1.02,2.69,1.42,4.08,.38,1.33,.71,2.69,.86,4.07,.14,1.33,.1,2.67-.14,3.98-.21,1.15-.58,2.32-1.33,3.24-1.26,1.54-3.39,1.62-5.14,.98-1.2-.44-2.3-1.12-3.3-1.91-2.09-1.65-3.73-3.81-5.15-6.04-1.54-2.42-2.81-5.02-3.79-7.71-.93-2.56-1.63-5.24-1.66-7.98-.02-1.27,.12-2.55,.53-3.76,.38-1.14,1.04-2.23,2.09-2.86,.17-.1,.34-.19,.52-.26,1.88-.76,4.05,.21,5.64,1.27Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-14",
  d: "M162.08,86.99c1.88-.76,4.05,.21,5.64,1.27,2.16,1.43,3.89,3.4,5.37,5.5,1.63,2.31,3,4.8,4.09,7.41,.55,1.33,1.02,2.69,1.42,4.08,.38,1.33,.71,2.69,.86,4.07,.14,1.33,.1,2.67-.14,3.98-.21,1.15-.58,2.32-1.33,3.24-1.26,1.54-3.39,1.62-5.14,.98-1.2-.44-2.3-1.12-3.3-1.91-2.09-1.65-3.73-3.81-5.15-6.04-1.54-2.42-2.81-5.02-3.79-7.71-.93-2.56-1.63-5.24-1.66-7.98-.02-1.27,.12-2.55,.53-3.76,.38-1.14,1.04-2.23,2.09-2.86,.17-.1,.34-.19,.52-.26Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M159.21,97.3c-.32-2.05-.45-4.22,.01-6.25,.1-.42,.21-.84,.37-1.25,.15-.38,.36-.73,.56-1.08,.15-.27,.31-.51,.52-.74,.25-.28,.54-.52,.86-.71,1.59-.97,3.55-.48,5.09,.34,1.64,.87,3.06,2.13,4.31,3.49,1.18,1.28,2.23,2.69,3.16,4.15,.14,.21,.27,.43,.4,.64,.19,.31,.36,.63,.53,.95,.19,.34,.38,.68,.57,1.02,.39,.7,.75,1.43,1.08,2.16,.9,2,1.64,4.06,2.17,6.18,.14,.55,.24,1.11,.37,1.66-.48-3.1-1.5-6.12-2.81-8.96-1.26-2.71-2.82-5.31-4.73-7.62-.83-1-1.73-1.94-2.72-2.79-.95-.81-2-1.54-3.15-2.03-1.15-.49-2.47-.76-3.69-.36-1.23,.41-2.07,1.46-2.57,2.61-.45,1.05-.65,2.21-.72,3.35-.09,1.4,0,2.81,.21,4.2,.05,.34,.1,.69,.17,1.03,0,0,0,0,0-.01Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-14",
  d: "M164.35,81.02s0,0,0,0c-1.26,.59-2.52,1.17-3.78,1.75-.18,.09-.37,.17-.55,.26,2.53-1.11,5.33,.13,7.44,1.58,2.55,1.75,4.67,4.13,6.47,6.62,2.26,3.12,4.11,6.56,5.52,10.14,1.41,3.56,2.45,7.33,2.74,11.16,.13,1.65,.11,3.32-.17,4.95-.3,1.75-.95,3.57-2.29,4.79-.32,.29-.68,.53-1.06,.73,1.22-.53,2.42-1.12,3.63-1.68,.2-.09,.4-.18,.59-.28,1.57-.73,2.54-2.3,3.06-3.9,.52-1.6,.66-3.31,.65-4.98-.03-3.53-.82-7.05-1.94-10.39-1.19-3.55-2.8-6.98-4.79-10.15-1.86-2.96-4.05-5.77-6.75-8-1.18-.98-2.48-1.85-3.91-2.42-1.27-.51-2.71-.8-4.07-.46-.27,.07-.55,.17-.8,.28Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-14",
  d: "M173.2,118.89c.81,.32,1.69,.51,2.56,.38,.96-.14,1.78-.68,2.37-1.42,.14-.17,.26-.36,.38-.55,.15-.24,.25-.5,.35-.75,.28-.66,.46-1.37,.58-2.07,.12-.71,.18-1.43,.19-2.15,.01-.79-.04-1.57-.11-2.36-.01-.12-.03-.24-.04-.36,.08,1.46,.04,2.95-.31,4.38-.27,1.07-.72,2.13-1.51,2.92-.55,.55-1.29,.81-2.06,.94-.83,.14-1.63,.02-2.43-.21-1-.29-1.92-.77-2.77-1.37-1.05-.75-2-1.64-2.88-2.59-1.04-1.13-1.97-2.35-2.82-3.62-.92-1.39-1.76-2.84-2.48-4.35-.71-1.47-1.34-2.98-1.86-4.53-.52-1.54-.93-3.12-1.21-4.72-.07-.4-.13-.79-.18-1.19,.05,.98,.19,1.97,.38,2.93s.41,1.92,.68,2.87c.29,.99,.62,1.97,.99,2.94,.38,1,.81,1.98,1.27,2.94,.19,.4,.39,.8,.62,1.17,.3,.49,.61,.98,.92,1.46,.61,.94,1.26,1.87,1.94,2.76,.64,.84,1.32,1.66,2.03,2.45,.69,.75,1.42,1.47,2.2,2.12,.8,.67,1.67,1.28,2.61,1.73,.18,.09,.37,.17,.56,.25Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M173.2,118.89c.81,.32,1.69,.51,2.56,.38,.96-.14,1.78-.68,2.37-1.42,.14-.17,.26-.36,.38-.55,.15-.24,.25-.5,.35-.75,.28-.66,.46-1.37,.58-2.07,.12-.71,.18-1.43,.19-2.15,.01-.79-.04-1.57-.11-2.36-.01-.12-.03-.24-.04-.36,.08,1.46,.04,2.95-.31,4.38-.27,1.07-.72,2.13-1.51,2.92-.55,.55-1.29,.81-2.06,.94-.83,.14-1.63,.02-2.43-.21-1-.29-1.92-.77-2.77-1.37-1.05-.75-2-1.64-2.88-2.59-1.04-1.13-1.97-2.35-2.82-3.62-.92-1.39-1.76-2.84-2.48-4.35-.71-1.47-1.34-2.98-1.86-4.53-.52-1.54-.93-3.12-1.21-4.72-.07-.4-.13-.79-.18-1.19,.05,.98,.19,1.97,.38,2.93s.41,1.92,.68,2.87c.29,.99,.62,1.97,.99,2.94,.38,1,.81,1.98,1.27,2.94,.19,.4,.39,.8,.62,1.17,.3,.49,.61,.98,.92,1.46,.61,.94,1.26,1.87,1.94,2.76,.64,.84,1.32,1.66,2.03,2.45,.69,.75,1.42,1.47,2.2,2.12,.8,.67,1.67,1.28,2.61,1.73,.18,.09,.37,.17,.56,.25Z"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-17"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M165.04,82.81l3.43-1.43c-.41-.13-.8-.23-1.19-.29l-3.28,1.37c.34,.09,.69,.21,1.04,.35Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M167.69,84.26c.07,.05,.14,.1,.2,.14l3.58-1.49c-.25-.17-.5-.33-.74-.48l-3.56,1.49c.17,.11,.35,.22,.52,.34Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M170.16,86.24l3.6-1.5c-.2-.18-.4-.36-.61-.53l-3.6,1.5c.2,.17,.4,.35,.6,.54Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M172.08,88.23l3.63-1.51c-.17-.19-.35-.38-.52-.57l-3.62,1.51c.17,.19,.34,.38,.52,.57Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M173.77,90.31l3.63-1.52c-.15-.2-.31-.4-.46-.6l-3.63,1.52c.15,.19,.31,.39,.46,.6Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M175.3,92.46l3.63-1.51c-.14-.21-.28-.41-.41-.62l-3.63,1.52c.14,.2,.28,.41,.42,.61Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M176.68,94.67l3.62-1.51c-.12-.21-.25-.42-.37-.63l-3.63,1.51c.13,.21,.25,.42,.38,.63Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M177.92,96.94l3.62-1.51c-.11-.22-.22-.43-.34-.65l-3.62,1.51c.11,.21,.23,.43,.34,.65Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M179.03,99.26l3.62-1.51c-.1-.22-.2-.44-.3-.66l-3.62,1.51c.1,.22,.2,.44,.3,.66Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M179.85,101.21c.06,.14,.11,.28,.16,.43l3.61-1.51c-.09-.23-.17-.45-.26-.68l-3.61,1.51c.03,.08,.07,.17,.1,.25Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M180.88,104.07l3.59-1.5c-.07-.22-.14-.44-.21-.66,0-.01,0-.02-.01-.04l-3.6,1.5c.08,.23,.16,.46,.23,.69Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M181.6,106.55l3.58-1.49c-.06-.23-.12-.47-.19-.71l-3.58,1.5c.07,.24,.13,.47,.19,.71Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M182.17,109.1l3.56-1.49c-.04-.24-.09-.49-.14-.73l-3.57,1.49c.05,.24,.1,.49,.14,.73Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M182.55,111.73l3.53-1.47c-.02-.25-.05-.5-.07-.76l-3.54,1.48c.03,.25,.06,.5,.09,.75Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M182.7,114.45l3.47-1.45c0-.26,0-.52,0-.79l-3.49,1.46c0,.27,.01,.53,.01,.78Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M182.48,117.33l3.35-1.4c.06-.28,.11-.56,.16-.85l-3.4,1.42c-.03,.28-.07,.56-.11,.83Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M181.54,120.51l2.8-1.17c.27-.34,.5-.71,.68-1.07l-3.09,1.29c-.12,.34-.25,.65-.39,.95Z"
})))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-13",
  d: "M112.13,124.16c2.76-2.75,5.35-5.7,7.63-8.84,.8-1.1,1.57-2.24,2.26-3.41,.68-1.16,1.32-2.39,1.67-3.69,.27-.98,.45-2.47-.75-2.89-.73-.26-1.59-.06-2.3,.14-.81,.24-1.58,.57-2.33,.94-4.05,2.01-7.66,4.96-11.02,7.95-2.96,2.64-5.76,5.47-8.34,8.48-2.34,2.73-4.63,5.63-6.23,8.86-.47,.95-.92,1.97-1.07,3.03-.09,.61-.08,1.34,.38,1.81,.47,.48,1.23,.49,1.86,.4,.75-.11,1.48-.36,2.18-.65,1.51-.63,2.94-1.47,4.31-2.36,2.68-1.74,5.18-3.76,7.58-5.87,1.43-1.26,2.83-2.56,4.18-3.91Zm-5.45,3.58c-1.26,1.04-2.55,2.06-3.89,2.99-.88,.61-1.78,1.18-2.71,1.69-.74,.4-1.49,.78-2.28,1.06-.67,.24-1.62,.52-2.29,.14-.42-.24-.53-.71-.52-1.16,.01-.51,.17-1.02,.34-1.5,.21-.57,.47-1.11,.75-1.65,.73-1.39,1.61-2.69,2.52-3.96,.22-.31,.46-.62,.68-.92,.73-.96,1.44-1.94,2.24-2.83,.82-.91,1.65-1.81,2.52-2.68,1.9-1.91,3.9-3.7,5.98-5.42,2.38-1.96,4.97-3.97,7.86-5.12,.45-.18,.91-.33,1.39-.42,.45-.08,.96-.13,1.38,.07,.71,.33,.71,1.19,.58,1.85-.15,.78-.47,1.54-.83,2.25-.87,1.74-2.01,3.34-3.19,4.88-1.41,1.83-2.96,3.57-4.57,5.23-1.71,1.76-3.51,3.45-5.39,5.03-.19,.16-.39,.33-.59,.49Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-14",
  d: "M106.68,127.74c-1.26,1.04-2.55,2.06-3.89,2.99-.88,.61-1.78,1.18-2.71,1.69-.74,.4-1.49,.78-2.28,1.06-.67,.24-1.62,.52-2.29,.14-.42-.24-.53-.71-.52-1.16,.01-.51,.17-1.02,.34-1.5,.21-.57,.47-1.11,.75-1.65,.73-1.39,1.61-2.69,2.52-3.96,.22-.31,.46-.62,.68-.92,.73-.96,1.44-1.94,2.24-2.83,.82-.91,1.65-1.81,2.52-2.68,1.9-1.91,3.9-3.7,5.98-5.42,2.38-1.96,4.97-3.97,7.86-5.12,.45-.18,.91-.33,1.39-.42,.45-.08,.96-.13,1.38,.07,.71,.33,.71,1.19,.58,1.85-.15,.78-.47,1.54-.83,2.25-.87,1.74-2.01,3.34-3.19,4.88-1.41,1.83-2.96,3.57-4.57,5.23-1.71,1.76-3.51,3.45-5.39,5.03-.19,.16-.39,.33-.59,.49Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-13",
  d: "M113.6,121.22c1.49-1.6,2.91-3.26,4.21-5.01,.99-1.34,1.94-2.74,2.67-4.24,.31-.63,.59-1.29,.74-1.98,.1-.46,.16-.98-.03-1.43-.42-.98-1.77-.69-2.57-.45-3.4,1.04-6.27,3.56-9.01,5.72,.6-.47,1.19-.95,1.8-1.41-.02,.02-.04,.03-.06,.05,1.14-.85,2.31-1.7,3.56-2.39,.42-.23,.84-.46,1.26-.68,.35-.18,.74-.31,1.11-.47,.89-.37,2.8-1.06,3.27,.25,.2,.54,.06,1.15-.07,1.67-.05,.18-.12,.38-.17,.54-.49,1.34-1.23,2.58-2.02,3.76-.77,1.16-1.64,2.31-2.51,3.38-.46,.58-1,1.22-1.49,1.76-.43,.49-.88,.98-1.33,1.46,.05-.06,.1-.11,.16-.17-.99,1.06-2.06,2.1-3.06,3.12-1.09,1.04-2.22,2.06-3.37,3.03,.01,0,0,0,0,0,2.17-1.74,4.2-3.67,6.13-5.67,.27-.28,.54-.56,.8-.84Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M113.6,121.22c1.49-1.6,2.91-3.26,4.21-5.01,.99-1.34,1.94-2.74,2.67-4.24,.31-.63,.59-1.29,.74-1.98,.1-.46,.16-.98-.03-1.43-.42-.98-1.77-.69-2.57-.45-3.4,1.04-6.27,3.56-9.01,5.72,.6-.47,1.19-.95,1.8-1.41-.02,.02-.04,.03-.06,.05,1.14-.85,2.31-1.7,3.56-2.39,.42-.23,.84-.46,1.26-.68,.35-.18,.74-.31,1.11-.47,.89-.37,2.8-1.06,3.27,.25,.2,.54,.06,1.15-.07,1.67-.05,.18-.12,.38-.17,.54-.49,1.34-1.23,2.58-2.02,3.76-.77,1.16-1.64,2.31-2.51,3.38-.46,.58-1,1.22-1.49,1.76-.43,.49-.88,.98-1.33,1.46,.05-.06,.1-.11,.16-.17-.99,1.06-2.06,2.1-3.06,3.12-1.09,1.04-2.22,2.06-3.37,3.03,.01,0,0,0,0,0,2.17-1.74,4.2-3.67,6.13-5.67,.27-.28,.54-.56,.8-.84Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-14",
  d: "M115.77,127.87c1.62-1.63,3.18-3.32,4.67-5.07,1.36-1.61,2.66-3.26,3.85-5,1.13-1.65,2.23-3.42,2.88-5.32,.24-.71,.46-1.51,.33-2.27-.09-.52-.39-.82-.74-1.18-1-1.02-2.01-2.05-3.01-3.07-.05-.05-.1-.1-.15-.15,.06,.12,.15,.29,.19,.43,.24,.88-.03,1.83-.33,2.66-.39,1.08-.93,2.11-1.51,3.1-1.36,2.31-2.98,4.45-4.69,6.51-2,2.4-4.14,4.68-6.38,6.85-2.66,2.57-5.47,5-8.46,7.17-1.39,1.01-2.82,1.96-4.33,2.79-.82,.45-1.66,.86-2.54,1.19-.82,.3-1.77,.6-2.65,.47-.34-.05-.64-.18-.9-.42,.89,.89,1.77,1.8,2.65,2.7,.33,.34,.65,.68,.99,1.01,.72,.7,1.92,.45,2.78,.21,2.23-.64,4.28-1.93,6.18-3.21,2.15-1.45,4.19-3.06,6.15-4.76,1.72-1.48,3.38-3.03,4.99-4.64Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M95.33,133.51c.19,.17,.48,.27,.87,.28,.63,.02,1.24-.18,1.83-.39,.78-.28,1.53-.69,2.25-1.09,1.74-.98,3.37-2.14,4.94-3.38-1.15,.83-2.3,1.65-3.52,2.36-.97,.56-2,1.1-3.08,1.41-.6,.17-1.38,.36-1.99,.06-.57-.28-.66-.95-.6-1.52,.11-1.07,.62-2.08,1.11-3.02,.52-.98,1.13-1.91,1.77-2.82,1.49-2.12,3.18-4.1,4.95-5.99,2.31-2.47,4.8-4.75,7.43-6.88-2.11,1.52-4.08,3.3-5.95,5.11-1.7,1.64-3.35,3.34-4.82,5.19-1.5,1.88-2.94,3.83-4.13,5.92-.48,.85-2.13,3.83-1.06,4.76Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M127.11,110.81l-2.9-2.9c-.06,.28-.14,.55-.22,.81l2.97,2.97c.08-.29,.13-.59,.15-.88Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M126.26,113.6l-3.03-3.03c-.11,.22-.22,.45-.35,.68l3.04,3.04c.12-.23,.23-.46,.33-.69Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M124.98,115.96l-3.06-3.06c-.13,.21-.26,.42-.4,.63l3.06,3.06c.13-.21,.27-.42,.4-.63Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M123.53,118.14l-3.06-3.06c-.14,.2-.28,.4-.43,.6l3.06,3.06c.15-.2,.29-.4,.43-.6Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M121.98,120.23l-3.06-3.06c-.15,.19-.3,.38-.45,.57l3.07,3.07c.15-.19,.3-.38,.45-.57Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M120.11,122.52c.08-.1,.16-.19,.24-.29l-3.07-3.07c-.16,.19-.31,.37-.47,.56l3.07,3.07c.08-.09,.16-.18,.23-.27Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M118.66,124.18l-3.07-3.07c-.16,.18-.32,.36-.49,.54l3.07,3.07c.16-.18,.33-.36,.49-.54Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M116.91,126.08l-3.08-3.08c-.17,.17-.34,.35-.5,.52l3.08,3.08c.17-.17,.34-.35,.5-.52Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M115.12,127.91l-3.08-3.08c-.17,.17-.35,.34-.52,.51l3.08,3.08c.17-.17,.35-.34,.52-.51Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M113.26,129.7l-3.07-3.07c-.18,.17-.36,.33-.53,.5l3.07,3.07c.18-.16,.36-.33,.53-.49Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M111.36,131.43l-3.07-3.07c-.18,.16-.36,.32-.55,.48l3.07,3.07c.18-.16,.37-.32,.55-.48Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M109.4,133.11l-3.07-3.07c-.19,.16-.38,.31-.56,.46l3.07,3.07c.19-.15,.37-.31,.56-.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M107.39,134.73l-3.07-3.07c-.19,.15-.39,.3-.58,.45l3.07,3.07c.19-.15,.39-.29,.58-.44Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M105.29,136.28l-3.07-3.07c-.2,.15-.41,.29-.6,.42l3.07,3.07c.2-.14,.4-.28,.61-.42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M103.12,137.74l-3.07-3.07c-.21,.13-.43,.27-.64,.39l3.07,3.07c.21-.13,.43-.26,.63-.39Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M100.81,139.07l-3.07-3.07c-.24,.12-.46,.24-.69,.34l3.06,3.06c.23-.11,.47-.22,.7-.33Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M98.2,140.09l-3.01-3.01c-.26,.09-.53,.16-.8,.22l2.96,2.96c.29-.03,.58-.1,.85-.18Z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-8",
  cx: 185.42,
  cy: 170.23,
  rx: 2.81,
  ry: 50.61
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M104.15,207.54l3.25-103.67c0-.22,.02-.45,.03-.67-4.23-.48-8.45-1.05-12.67-1.71-.18,1.41-.28,2.83-.28,4.26v103.72c0,7.93,2.01,11.63,6.91,16.35,.86,.83,2.3,.32,2.45-.86,.43-3.46,.09-10.53,.31-17.42Z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M197.22,93.7l-5.17-9.76c-1.89-3.57-2.88-7.56-2.88-11.6v-11.21H91.63v11.17c0,4.07-1,8.08-2.92,11.67l-5.19,9.73c-2.55,4.79-3.89,10.13-3.89,15.55v103.72c0,16.29,13.21,29.5,29.5,29.5h62.48c16.29,0,29.5-13.21,29.5-29.5V109.25c0-5.43-1.34-10.77-3.89-15.55Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M201.09,108.26c0-.11-.01-.23-.02-.34,0-.21-.02-.43-.03-.64,0-.14-.02-.28-.03-.42-.01-.19-.03-.37-.04-.56-.01-.16-.03-.31-.05-.46-.02-.17-.03-.34-.06-.51-.02-.16-.04-.33-.06-.49-.02-.16-.04-.32-.07-.48-.03-.17-.05-.34-.08-.51-.02-.15-.05-.3-.08-.45-.03-.18-.07-.36-.1-.53-.03-.14-.06-.28-.08-.42-.04-.18-.08-.37-.12-.55-.03-.13-.06-.26-.09-.39-.05-.19-.09-.38-.14-.57-.03-.12-.06-.25-.1-.37-.05-.2-.11-.39-.17-.59-.03-.11-.07-.23-.1-.34-.06-.2-.12-.4-.19-.6-.03-.1-.07-.21-.1-.31-.07-.21-.14-.42-.22-.62-.03-.09-.07-.18-.1-.28-.08-.22-.16-.43-.24-.65-.03-.08-.06-.16-.1-.24-.09-.22-.18-.45-.28-.67-.03-.06-.06-.13-.08-.19-.1-.24-.21-.47-.32-.71-.02-.04-.04-.08-.06-.12-.24-.52-.5-1.03-.77-1.54l-5.17-9.76c-1.89-3.57-2.88-7.56-2.88-11.6v-11.21h-1.82s-.36,11.21-.36,11.21c0,4.04,.94,8.03,2.75,11.6l4.93,9.76c2.44,4.79,3.71,10.13,3.71,15.55v95.72c0,14.77-12.01,26.78-26.78,26.78h-62.48c-14.77,0-26.78-12.01-26.78-26.78V109.25c0-5.42,1.28-10.76,3.71-15.55l4.96-9.73c1.83-3.59,2.79-7.6,2.79-11.67l-.36-11.17h-1.82v11.17c0,4.07-1,8.08-2.92,11.67l-5.19,9.73c-.14,.26-.27,.52-.4,.78h0s0,0,0,0c-.13,.25-.25,.51-.37,.76-.02,.04-.04,.08-.06,.12-.11,.23-.21,.47-.32,.71-.03,.06-.06,.13-.08,.19-.1,.22-.19,.45-.28,.67-.03,.08-.06,.16-.1,.24-.08,.21-.16,.43-.24,.64-.03,.09-.07,.18-.1,.28-.07,.21-.15,.41-.22,.62-.03,.1-.07,.21-.1,.31-.07,.2-.13,.4-.19,.6-.03,.11-.07,.23-.1,.34-.06,.19-.11,.39-.17,.59-.03,.12-.07,.24-.1,.37-.05,.19-.1,.38-.14,.57-.03,.13-.06,.26-.09,.39-.04,.18-.08,.37-.12,.55-.03,.14-.06,.28-.08,.42-.04,.18-.07,.36-.1,.53-.03,.15-.05,.3-.08,.45-.03,.17-.06,.34-.08,.51-.02,.16-.04,.32-.07,.48-.02,.16-.05,.33-.06,.49-.02,.17-.04,.34-.06,.51-.02,.15-.03,.31-.05,.46-.02,.19-.03,.37-.04,.56-.01,.14-.02,.28-.03,.42-.01,.21-.02,.43-.03,.64,0,.11-.01,.23-.02,.34,0,.33-.02,.66-.02,.99v103.72c0,16.29,13.21,29.5,29.5,29.5h62.48c16.29,0,29.5-13.21,29.5-29.5V109.25c0-.33,0-.66-.02-.99Z"
}), /*#__PURE__*/React.createElement("g", {
  className: "cls-18"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M189.53,76.5c1.21-.21,2.11-1.28,2.07-2.54-.04-1.33-1.11-2.38-2.43-2.42v.79c0,1.4,.12,2.79,.36,4.17Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M91.63,71.54c-1.31,.04-2.39,1.09-2.43,2.42-.04,1.26,.86,2.32,2.06,2.53,.24-1.38,.36-2.79,.36-4.21v-.75Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M93.45,76.59c31.29,.95,62.6,.95,93.9,0-.23-1.4-.35-2.83-.35-4.26v-.73c-31.05,.94-62.13,.94-93.18,0v.69c0,1.45-.12,2.89-.36,4.3Z"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-16"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "cls-13",
  cx: 114.22,
  cy: 178.55,
  r: 21.53
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-14",
  cx: 114.22,
  cy: 178.55,
  r: 17.18
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M115.18,162.61c5.25,0,9.96,2.36,13.11,6.08-3.11-4.43-8.25-7.32-14.07-7.32-9.49,0-17.18,7.69-17.18,17.18,0,4.24,1.53,8.11,4.07,11.11-1.96-2.79-3.11-6.19-3.11-9.87,0-9.49,7.69-17.18,17.18-17.18Z"
})), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M114.24,195.78c-4.58,0-8.75-1.8-11.83-4.72,3.13,3.3,7.56,5.35,12.46,5.35,9.49,0,17.18-7.69,17.18-17.18,0-4.91-2.06-9.33-5.35-12.46,2.93,3.08,4.72,7.25,4.72,11.83,0,9.49-7.69,17.18-17.18,17.18Z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  className: "cls-14",
  x: 114.62,
  y: 206.27,
  width: 7.92,
  height: 43.03,
  rx: 2.58,
  ry: 2.58,
  transform: "translate(346.37 109.21) rotate(90)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 138.43,
  y: 224.42,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 135.92,
  y: 224.42,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 133.41,
  y: 224.42,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 130.89,
  y: 224.42,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 128.38,
  y: 224.42,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 125.87,
  y: 224.42,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 123.36,
  y: 224.42,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 120.84,
  y: 224.42,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 118.33,
  y: 224.42,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 115.82,
  y: 224.42,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 113.3,
  y: 224.42,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 110.79,
  y: 224.42,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 108.28,
  y: 224.42,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 105.77,
  y: 224.42,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 103.25,
  y: 224.42,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 100.62,
  y: 224.42,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 98.1,
  y: 224.42,
  width: 0.71,
  height: 6.73
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  className: "cls-14",
  x: 110.16,
  y: 198.36,
  width: 7.92,
  height: 43.03,
  rx: 2.58,
  ry: 2.58,
  transform: "translate(333.99 105.75) rotate(90)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 133.97,
  y: 216.51,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 131.46,
  y: 216.51,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 128.95,
  y: 216.51,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 126.43,
  y: 216.51,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 123.92,
  y: 216.51,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 121.41,
  y: 216.51,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 118.89,
  y: 216.51,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 116.38,
  y: 216.51,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 113.87,
  y: 216.51,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 111.36,
  y: 216.51,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 108.84,
  y: 216.51,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 106.33,
  y: 216.51,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 103.82,
  y: 216.51,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 101.3,
  y: 216.51,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 98.79,
  y: 216.51,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 96.16,
  y: 216.51,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 93.64,
  y: 216.51,
  width: 0.71,
  height: 6.73
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  className: "cls-14",
  x: 104.78,
  y: 190.44,
  width: 7.92,
  height: 43.03,
  rx: 2.58,
  ry: 2.58,
  transform: "translate(320.69 103.22) rotate(90)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 128.59,
  y: 208.59,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 126.08,
  y: 208.59,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 123.57,
  y: 208.59,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 121.05,
  y: 208.59,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 118.54,
  y: 208.59,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 116.03,
  y: 208.59,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 113.51,
  y: 208.59,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 111,
  y: 208.59,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 108.49,
  y: 208.59,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 105.98,
  y: 208.59,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 103.46,
  y: 208.59,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 100.95,
  y: 208.59,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 98.44,
  y: 208.59,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 95.92,
  y: 208.59,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 93.41,
  y: 208.59,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 90.78,
  y: 208.59,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 88.26,
  y: 208.59,
  width: 0.71,
  height: 6.73
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  className: "cls-14",
  x: 117.7,
  y: 182.52,
  width: 7.92,
  height: 43.03,
  rx: 2.58,
  ry: 2.58,
  transform: "translate(325.7 82.38) rotate(90)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 141.51,
  y: 200.67,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 139,
  y: 200.67,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 136.48,
  y: 200.67,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 133.97,
  y: 200.67,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 131.46,
  y: 200.67,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 128.95,
  y: 200.67,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 126.43,
  y: 200.67,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 123.92,
  y: 200.67,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 121.41,
  y: 200.67,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 118.89,
  y: 200.67,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 116.38,
  y: 200.67,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 113.87,
  y: 200.67,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 111.36,
  y: 200.67,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 108.84,
  y: 200.67,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 106.33,
  y: 200.67,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 103.69,
  y: 200.67,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 101.18,
  y: 200.67,
  width: 0.71,
  height: 6.73
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  className: "cls-14",
  x: 161.08,
  y: 206.27,
  width: 7.92,
  height: 43.03,
  rx: 2.58,
  ry: 2.58,
  transform: "translate(392.82 62.75) rotate(90)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 184.89,
  y: 224.42,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 182.37,
  y: 224.42,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 179.86,
  y: 224.42,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 177.35,
  y: 224.42,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 174.84,
  y: 224.42,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 172.32,
  y: 224.42,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 169.81,
  y: 224.42,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 167.3,
  y: 224.42,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 164.78,
  y: 224.42,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 162.27,
  y: 224.42,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 159.76,
  y: 224.42,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 157.25,
  y: 224.42,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 154.73,
  y: 224.42,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 152.22,
  y: 224.42,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 149.71,
  y: 224.42,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 147.07,
  y: 224.42,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 144.56,
  y: 224.42,
  width: 0.71,
  height: 6.73
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  className: "cls-14",
  x: 161.08,
  y: 174.62,
  width: 7.92,
  height: 43.03,
  rx: 2.58,
  ry: 2.58,
  transform: "translate(361.17 31.1) rotate(90)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 184.89,
  y: 192.77,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 182.37,
  y: 192.77,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 179.86,
  y: 192.77,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 177.35,
  y: 192.77,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 174.84,
  y: 192.77,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 172.32,
  y: 192.77,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 169.81,
  y: 192.77,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 167.3,
  y: 192.77,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 164.78,
  y: 192.77,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 162.27,
  y: 192.77,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 159.76,
  y: 192.77,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 157.25,
  y: 192.77,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 154.73,
  y: 192.77,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 152.22,
  y: 192.77,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 149.71,
  y: 192.77,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 147.07,
  y: 192.77,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 144.56,
  y: 192.77,
  width: 0.71,
  height: 6.73
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  className: "cls-14",
  x: 159.02,
  y: 198.36,
  width: 7.92,
  height: 43.03,
  rx: 2.58,
  ry: 2.58,
  transform: "translate(382.85 56.89) rotate(90)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 182.83,
  y: 216.51,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 180.32,
  y: 216.51,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 177.81,
  y: 216.51,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 175.3,
  y: 216.51,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 172.78,
  y: 216.51,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 170.27,
  y: 216.51,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 167.76,
  y: 216.51,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 165.24,
  y: 216.51,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 162.73,
  y: 216.51,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 160.22,
  y: 216.51,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 157.71,
  y: 216.51,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 155.19,
  y: 216.51,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 152.68,
  y: 216.51,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 150.17,
  y: 216.51,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 147.66,
  y: 216.51,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 145.02,
  y: 216.51,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 142.51,
  y: 216.51,
  width: 0.71,
  height: 6.73
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  className: "cls-14",
  x: 156.72,
  y: 190.44,
  width: 7.92,
  height: 43.03,
  rx: 2.58,
  ry: 2.58,
  transform: "translate(372.63 51.28) rotate(90)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 180.53,
  y: 208.59,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 178.02,
  y: 208.59,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 175.51,
  y: 208.59,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 172.99,
  y: 208.59,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 170.48,
  y: 208.59,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 167.97,
  y: 208.59,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 165.45,
  y: 208.59,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 162.94,
  y: 208.59,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 160.43,
  y: 208.59,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 157.92,
  y: 208.59,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 155.4,
  y: 208.59,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 152.89,
  y: 208.59,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 150.38,
  y: 208.59,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 147.86,
  y: 208.59,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 145.35,
  y: 208.59,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 142.72,
  y: 208.59,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 140.2,
  y: 208.59,
  width: 0.71,
  height: 6.73
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  className: "cls-14",
  x: 164.51,
  y: 182.52,
  width: 7.92,
  height: 43.03,
  rx: 2.58,
  ry: 2.58,
  transform: "translate(372.51 35.57) rotate(90)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 188.32,
  y: 200.67,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 185.81,
  y: 200.67,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 183.29,
  y: 200.67,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 180.78,
  y: 200.67,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 178.27,
  y: 200.67,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 175.76,
  y: 200.67,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 173.24,
  y: 200.67,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 170.73,
  y: 200.67,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 168.22,
  y: 200.67,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 165.7,
  y: 200.67,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 163.19,
  y: 200.67,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 160.68,
  y: 200.67,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 158.17,
  y: 200.67,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 155.65,
  y: 200.67,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 153.14,
  y: 200.67,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 150.5,
  y: 200.67,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 147.99,
  y: 200.67,
  width: 0.71,
  height: 6.73
})), /*#__PURE__*/React.createElement("path", {
  className: "cls-12",
  d: "M132.97,189.66h0c-2.42-.35-4.33-2.25-4.67-4.67h0s0,0,0,0c-.35,2.42-2.25,4.33-4.67,4.67h0c2.42,.35,4.33,2.25,4.67,4.67h0s0,0,0,0c.35-2.42,2.25-4.33,4.67-4.67Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-12",
  d: "M106.33,160.84h0c-2.42-.35-4.33-2.25-4.67-4.67h0c-.35,2.42-2.25,4.33-4.67,4.67h0c2.42,.35,4.33,2.25,4.67,4.67h0c.35-2.42,2.25-4.33,4.67-4.67Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M139.15,223.85h-9.85s0,.46,0,.46c0,3.65-2.96,6.61-6.61,6.61h-25.59c.09,.47,.4,.82,.76,.82h41.44c.36,0,.66-.34,.76-.8h0c-.04,.2-.12,.38-.22,.52,.16-.17,.25-.39,.25-.64v-6.02c0-.52-.42-.95-.94-.95Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M144.48,223.85h9.85s0,.46,0,.46c0,3.65,2.96,6.61,6.61,6.61h25.59c-.09,.47-.4,.82-.76,.82h-41.44c-.36,0-.66-.34-.76-.8h0c.04,.2,.12,.38,.22,.52-.16-.17-.25-.39-.25-.64v-6.02c0-.52,.42-.95,.94-.95Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M147.91,200.09h9.85s0,.46,0,.46c0,3.65,2.96,6.61,6.61,6.61h25.59c-.09,.47-.4,.82-.76,.82h-41.44c-.36,0-.66-.34-.76-.8h0c.04,.2,.12,.38,.22,.52-.16-.17-.25-.39-.25-.64v-6.02c0-.52,.42-.95,.94-.95Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M135.63,216.86c0-.52-.42-.95-.95-.95h-5.6s-4.46,0-4.46,0v1.99c0,2.82-2.29,5.11-5.11,5.11h-26.89c.09,.47,.4,.82,.76,.82h41.44c.22,0,.42-.13,.57-.34,.14-.16,.22-.37,.22-.6v-6.02Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M129.31,208h-10.98s0,.87,0,.87c0,3.44-2.79,6.22-6.22,6.22h-24.85c.09,.47,.4,.82,.76,.82h41.44c.22,0,.42-.13,.56-.33,.14-.17,.23-.38,.23-.61v-6.02c0-.52-.42-.95-.94-.95Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M159.44,215.09h0s-11.6,0-11.6,0c-2.59,0-4.7-2.1-4.7-4.7v-2.4h-3.03c-.52,0-.95,.43-.94,.95v6.02c0,.23,.09,.45,.23,.61,.14,.2,.34,.33,.56,.33h41.44c.36,0,.67-.35,.76-.82h-22.72Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M163.81,199.26h0s-11.6,0-11.6,0c-2.59,0-4.7-2.1-4.7-4.7v-2.4h-3.03c-.52,0-.95,.43-.94,.95v6.02c0,.23,.09,.45,.23,.61,.14,.2,.34,.33,.56,.33h41.44c.36,0,.67-.35,.76-.82h-22.72Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M122.89,207.17h0s11.6,0,11.6,0c2.59,0,4.7-2.1,4.7-4.7v-2.4h3.03c.52,0,.95,.43,.94,.95v6.02c0,.23-.09,.45-.23,.61-.14,.2-.34,.33-.56,.33h-41.44c-.36,0-.67-.35-.76-.82h22.72Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M157.58,223.01c-.1,0-.19,0-.29,0h-1.78c-3.83,0-6.94-3.11-6.94-6.94v-.16h-6.16c-.52,0-.95,.43-.95,.95v6.02c0,.23,.09,.44,.23,.6,.14,.21,.34,.34,.57,.34h41.44c.36,0,.67-.35,.76-.82h-26.89Z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  className: "cls-14",
  x: 152.51,
  y: 167.09,
  width: 7.92,
  height: 43.03,
  rx: 2.58,
  ry: 2.58,
  transform: "translate(345.07 32.13) rotate(90)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 176.32,
  y: 185.24,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 173.81,
  y: 185.24,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 171.3,
  y: 185.24,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 168.78,
  y: 185.24,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 166.27,
  y: 185.24,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 163.76,
  y: 185.24,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 161.24,
  y: 185.24,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 158.73,
  y: 185.24,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 156.22,
  y: 185.24,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 153.71,
  y: 185.24,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 151.19,
  y: 185.24,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 148.68,
  y: 185.24,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 146.17,
  y: 185.24,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 143.65,
  y: 185.24,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 141.14,
  y: 185.24,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 138.51,
  y: 185.24,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 135.99,
  y: 185.24,
  width: 0.71,
  height: 6.73
})), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M155.23,191.74h0s-11.6,0-11.6,0c-2.59,0-4.7-2.1-4.7-4.7v-2.4h-3.03c-.52,0-.95,.43-.94,.95v6.02c0,.23,.09,.45,.23,.61,.14,.2,.34,.33,.56,.33h41.44c.36,0,.67-.35,.76-.82h-22.72Z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  className: "cls-14",
  x: 162.97,
  y: 159.17,
  width: 7.92,
  height: 43.03,
  rx: 2.58,
  ry: 2.58,
  transform: "translate(347.61 13.76) rotate(90)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 186.78,
  y: 177.32,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 184.27,
  y: 177.32,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 181.76,
  y: 177.32,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 179.24,
  y: 177.32,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 176.73,
  y: 177.32,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 174.22,
  y: 177.32,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 171.7,
  y: 177.32,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 169.19,
  y: 177.32,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 166.68,
  y: 177.32,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 164.17,
  y: 177.32,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 161.65,
  y: 177.32,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 159.14,
  y: 177.32,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 156.63,
  y: 177.32,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 154.11,
  y: 177.32,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 151.6,
  y: 177.32,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 148.97,
  y: 177.32,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 146.45,
  y: 177.32,
  width: 0.71,
  height: 6.73
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  className: "cls-14",
  x: 158.51,
  y: 151.25,
  width: 7.92,
  height: 43.03,
  rx: 2.58,
  ry: 2.58,
  transform: "translate(335.24 10.3) rotate(90)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 182.32,
  y: 169.4,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 179.81,
  y: 169.4,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 177.29,
  y: 169.4,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 174.78,
  y: 169.4,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 172.27,
  y: 169.4,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 169.76,
  y: 169.4,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 167.24,
  y: 169.4,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 164.73,
  y: 169.4,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 162.22,
  y: 169.4,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 159.71,
  y: 169.4,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 157.19,
  y: 169.4,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 154.68,
  y: 169.4,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 152.17,
  y: 169.4,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 149.65,
  y: 169.4,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 147.14,
  y: 169.4,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 144.51,
  y: 169.4,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 141.99,
  y: 169.4,
  width: 0.71,
  height: 6.73
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  className: "cls-14",
  x: 153.13,
  y: 143.34,
  width: 7.92,
  height: 43.03,
  rx: 2.58,
  ry: 2.58,
  transform: "translate(321.94 7.76) rotate(90)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 176.94,
  y: 161.49,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 174.43,
  y: 161.49,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 171.91,
  y: 161.49,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 169.4,
  y: 161.49,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 166.89,
  y: 161.49,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 164.38,
  y: 161.49,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 161.86,
  y: 161.49,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 159.35,
  y: 161.49,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 156.84,
  y: 161.49,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 154.32,
  y: 161.49,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 151.81,
  y: 161.49,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 149.3,
  y: 161.49,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 146.79,
  y: 161.49,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 144.27,
  y: 161.49,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 141.76,
  y: 161.49,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 139.12,
  y: 161.49,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 136.61,
  y: 161.49,
  width: 0.71,
  height: 6.73
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  className: "cls-14",
  x: 166.05,
  y: 135.42,
  width: 7.92,
  height: 43.03,
  rx: 2.58,
  ry: 2.58,
  transform: "translate(326.94 -13.07) rotate(90)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 189.86,
  y: 153.57,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 187.35,
  y: 153.57,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 184.83,
  y: 153.57,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 182.32,
  y: 153.57,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 179.81,
  y: 153.57,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 177.29,
  y: 153.57,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 174.78,
  y: 153.57,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 172.27,
  y: 153.57,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 169.76,
  y: 153.57,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 167.24,
  y: 153.57,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 164.73,
  y: 153.57,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 162.22,
  y: 153.57,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 159.71,
  y: 153.57,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 157.19,
  y: 153.57,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 154.68,
  y: 153.57,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 152.04,
  y: 153.57,
  width: 0.71,
  height: 6.73
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-10",
  x: 149.53,
  y: 153.57,
  width: 0.71,
  height: 6.73
})), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M187.5,176.75h-9.85s0,.46,0,.46c0,3.65-2.96,6.61-6.61,6.61h-25.59c.09,.47,.4,.82,.76,.82h41.44c.36,0,.66-.34,.76-.8h0c-.04,.2-.12,.38-.22,.52,.16-.17,.25-.39,.25-.64v-6.02c0-.52-.42-.95-.94-.95Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M183.98,169.76c0-.52-.42-.95-.95-.95h-5.6s-4.46,0-4.46,0v1.99c0,2.82-2.29,5.11-5.11,5.11h-26.89c.09,.47,.4,.82,.76,.82h41.44c.22,0,.42-.13,.57-.34,.14-.16,.22-.37,.22-.6v-6.02Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M177.66,160.9h-10.98s0,.87,0,.87c0,3.44-2.79,6.22-6.22,6.22h-24.85c.09,.47,.4,.82,.76,.82h41.44c.22,0,.42-.13,.56-.33,.14-.17,.23-.38,.23-.61v-6.02c0-.52-.42-.95-.94-.95Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M171.24,160.07h0s11.6,0,11.6,0c2.59,0,4.7-2.1,4.7-4.7v-2.4h3.03c.52,0,.95,.43,.94,.95v6.02c0,.23-.09,.45-.23,.61-.14,.2-.34,.33-.56,.33h-41.44c-.36,0-.67-.35-.76-.82h22.72Z"
})))), /*#__PURE__*/React.createElement("rect", {
  className: "cls-7",
  x: 91.63,
  y: 53.57,
  width: 97.54,
  height: 7.55
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-11",
  x: 91.63,
  y: 53.56,
  width: 1.82,
  height: 7.56
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-11",
  x: 187.36,
  y: 53.56,
  width: 1.82,
  height: 7.56
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-9",
  x: 88.61,
  y: 49.19,
  width: 102.21,
  height: 4.36,
  rx: 1.42,
  ry: 1.42
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-9",
  x: 93.45,
  y: 56.31,
  width: 93.91,
  height: 2.05
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M189.8,58.36c.56,0,1.02-.46,1.02-1.02s-.46-1.02-1.02-1.02h-.62v2.05h.62Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M89.63,56.31c-.56,0-1.02,.46-1.02,1.02s.46,1.02,1.02,1.02h2v-2.05h-2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M89.63,60.54c-.56,0-1.02,.46-1.02,1.02s.46,1.02,1.02,1.02h2v-2.05h-2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M189.8,62.59c.56,0,1.02-.46,1.02-1.02s-.46-1.02-1.02-1.02h-.62v2.05h.62Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "93.45 60.54 93.5 62.59 187.31 62.59 187.36 60.54 93.45 60.54"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M89.63,65.31c-.56,0-1.02,.46-1.02,1.02s.46,1.02,1.02,1.02h2v-2.05h-2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M189.8,67.36c.56,0,1.02-.46,1.02-1.02s-.46-1.02-1.02-1.02h-.62v2.05h.62Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-9",
  points: "93.58 65.31 93.65 67.36 187.15 67.36 187.22 65.31 93.58 65.31"
}))), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M120.19,104.36c5.1,4.09,18.99,6.8,35.27,6.44,19.16-.42,34.83-4.95,36.69-10.36-23.86,4.27-47.95,5.58-71.95,3.92Z"
}))));

function SvgQ1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 279.72 279.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQ1);
export default __webpack_public_path__ + "static/media/q1.d5ca78ffe15f57f6f63a7fa05c52bb37.svg";
export { ForwardRef as ReactComponent };